type Grecaptcha = {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

function getGrecaptcha(): Promise<Grecaptcha> {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (typeof window !== "undefined" && "grecaptcha" in window && window.grecaptcha) {
        clearInterval(interval);
        resolve(window.grecaptcha as Grecaptcha);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(interval);
      reject("grecaptcha not available after timeout.");
    }, 5000);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  function initializeContactForm(): void {
    const form = document.getElementById("contact-form") as HTMLFormElement | null;
    let isSubmitting = false;
    let delay: number;

    function updateFormGroups(form: HTMLFormElement | null): void {
      if (!form) return;
      const inputs = form.querySelectorAll("input, textarea, select");
      inputs.forEach((input) => {
        const formGroup = input.closest(".form-group");
        if (input.classList.contains("input-validation-error")) {
          formGroup?.classList.add("has-error");
        } else {
          formGroup?.classList.remove("has-error");
        }
      });
    }

    function isFormValid(form: HTMLFormElement | null): boolean {
      if (!form) return false;
      const invalidInputs = form.querySelectorAll(".input-validation-error");
      console.log("Invalid Inputs:", invalidInputs.length);
      return invalidInputs.length === 0;
    }

    function delayedValidation(form: HTMLFormElement | null): void {
      clearTimeout(delay);
      delay = window.setTimeout(() => updateFormGroups(form), 200);
    }

    function generateRecaptchaCode(callback: () => void): void {
      const siteKeyElement = document.getElementById("site-key");
      const siteKey = siteKeyElement?.getAttribute("data-site-key");

      if (!siteKey) {
        console.error("Site key not found.");
        return;
      }

      getGrecaptcha()
        .then((grecaptcha) => {
          grecaptcha.ready(() => {
            grecaptcha.execute(siteKey, { action: "contactForm" }).then((token) => {
              const containers = document.querySelectorAll(".js-google-recapture-code");
              containers.forEach((container) => {
                (container as HTMLInputElement).value = token;
              });
              callback();
            });
          });
        })
        .catch((err) => {
          console.error("Failed to load grecaptcha:", err);
        });
    }

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault(); // Always prevent default submit

        if (isSubmitting) {
          console.log("Already submitting, please wait.");
          return;
        }

        updateFormGroups(form);

        setTimeout(() => {
          if (isFormValid(form)) {
            console.log("Valid form. Requesting reCAPTCHA...");
            isSubmitting = true;

            generateRecaptchaCode(() => {
              console.log("Token injected. Submitting via AJAX...");

              const formData = new FormData(form);

              fetch(form.action, {
                method: form.method,
                body: formData,
                headers: {
                  "X-Requested-With": "XMLHttpRequest"
                }
              })
                .then((response) => response.text())
                .then((htmlOrText) => {
                  isSubmitting = false;

                  const updateSelector = form.getAttribute("data-ajax-update");
                  if (!updateSelector) {
                    console.warn("Missing data-ajax-update on form.");
                    return;
                  }

                  const target = document.querySelector(updateSelector);
                  if (!target) {
                    console.warn(`No element found for selector: ${updateSelector}`);
                    return;
                  }

                  target.innerHTML = htmlOrText;
                })
                .catch((error) => {
                  console.error("AJAX form submission failed", error);
                  isSubmitting = false;
                });
            });
          } else {
            console.log("Validation failed.");
            updateFormGroups(form);
          }
        }, 50);
      });

      form.addEventListener("input", () => delayedValidation(form));
      form.addEventListener("change", () => delayedValidation(form));
    }
  }

  initializeContactForm();
});
